import { FormEvent, useEffect, useState } from "react"
import { apiFetch } from "../../lib/api"
import { useEmpresa } from "../../app/context/EmpresaContext"

export const WebhooksPage = () => {
  const { empresaId } = useEmpresa()
  const [hooks, setHooks] = useState<{ id: string; url: string; eventos: string[] }[]>([])
  const [secret, setSecret] = useState("")
  const [url, setUrl] = useState("")

  const load = async () => {
    if (!empresaId) return
    setHooks(await apiFetch(`/v1/empresas/${empresaId}/webhooks`))
  }

  useEffect(() => {
    load()
  }, [empresaId])

  const handleCreate = async (e: FormEvent) => {
    e.preventDefault()
    if (!empresaId) return
    const res = await apiFetch<{ secret: string }>(`/v1/empresas/${empresaId}/webhooks`, {
      method: "POST",
      body: JSON.stringify({ url, eventos: ["nfe.autorizado", "nfe.rejeitado", "nfe.erro"] }),
    })
    setSecret(res.secret)
    setUrl("")
    await load()
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Webhooks</h1>
      <form onSubmit={handleCreate} className="rounded-xl border border-slate-200 bg-white p-5 space-y-3">
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://erp.exemplo/webhook" required className="w-full rounded-lg border px-3 py-2 text-sm" />
        <button type="submit" className="rounded-lg bg-brand-600 px-4 py-2 text-sm text-white">Cadastrar</button>
      </form>
      {secret && <p className="rounded-lg bg-amber-50 p-3 text-sm">Secret (guarde agora): <code>{secret}</code></p>}
      <ul className="rounded-xl border bg-white divide-y">
        {hooks.map((h) => (
          <li key={h.id} className="px-5 py-3 text-sm">{h.url} — {h.eventos.join(", ")}</li>
        ))}
      </ul>
    </div>
  )
}
